import * as React from 'react'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Typography from '@mui/material/Typography'
import DialogTitle from '@mui/material/DialogTitle'
import MuiDialog from '@mui/material/Dialog'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

type Props = {
  onClose: () => void
  onDelete: () => void
  open: boolean
  disabled: boolean
}

export function DeleteAssignmentRuleDialog(props: Props) {
  const { onClose, onDelete, open, disabled } = props
  const theme = useTheme()
  return (
    <MuiDialog open={open} onClose={onClose} maxWidth="sm">
      <DialogTitle
        color={theme.palette.text.primary}
        fontFamily="Source Sans Pro Semibold"
        fontSize={20}
        lineHeight="32px"
        letterSpacing="0.15px"
      >
        Delete Assignment Rule
      </DialogTitle>
      <DialogContent>
        <Typography letterSpacing="0.15px" fontSize="16px" width={577}>
          Are you sure you want to delete this assignment rule? You can turn it
          off instead if you plan to use it in the future.
        </Typography>
      </DialogContent>
      <Box padding={1.2} paddingTop={0}>
        <DialogActions>
          <Button
            onClick={onClose}
            color="primary"
            data-test-id="assignmentRuleDeletePopup_cancel"
          >
            <Typography
              fontFamily="Source Sans Pro Semibold"
              color="rgba(0, 62, 128, 1)"
              letterSpacing="0.4px"
            >
              Cancel
            </Typography>
          </Button>
          <Button
            disabled={disabled}
            onClick={onDelete}
            variant="contained"
            sx={{ background: 'rgba(25, 48, 90, 1)' }}
            data-test-id="assignmentRuleDeletePopup_delete"
          >
            <Typography
              fontFamily="Source Sans Pro Semibold"
              letterSpacing="0.4px"
            >
              Delete
            </Typography>
          </Button>
        </DialogActions>
      </Box>
    </MuiDialog>
  )
}
